/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {TableCell, TableHead, TableRow} from '@mui/material';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {FeatureFlagSet, FeatureFlags} from '../../../../flags';

export const TableHeader = () => {
  const flags = useFlags<FeatureFlagSet>();
  const showTestButton = flags[FeatureFlags.testAgent];

  return (
    <TableHead>
      <TableRow>
        {showTestButton && (
          <TableCell width={'15%'} align={'center'}>
            Actions
          </TableCell>
        )}
        <TableCell width={'25%'}>Name</TableCell>
        <TableCell width={'35%'}>Details</TableCell>
        <TableCell width={'25%'}>Last Updated</TableCell>
      </TableRow>
    </TableHead>
  );
};
